import type { MessagingChannelsCopy } from './types';

export const VI: MessagingChannelsCopy = {
  title: 'Nhắn tin',
  description:
    'Trò chuyện với IMAI từ các ứng dụng chat bạn đang dùng. Kết nối một lần rồi nhắn cho IMAI ngay tại đó.',
  privacy:
    'Tin nhắn từ các tài khoản đã kết nối sẽ chạy dưới danh nghĩa của bạn trong không gian làm việc này và dùng tín dụng của bạn.',
  loading: 'Đang tải các kênh nhắn tin',
  unavailable: 'Chưa khả dụng',
  unavailableNote: '{channel} chưa được thiết lập cho IMAI.',
  connectedBadge: 'Đã kết nối',
  cancel: 'Hủy',

  addNumber: 'Thêm số',
  countryLabel: 'Mã quốc gia',
  countrySearch: 'Tìm quốc gia hoặc mã…',
  countryEmpty: 'Không tìm thấy quốc gia.',
  numberLabel: 'Số điện thoại',
  continueActivation: 'Tiếp tục',
  editNumber: 'Đổi số',
  activateQr: 'Quét rồi nhấn Gửi',
  activateHint: 'Mở {channel} rồi nhấn Gửi.',
  activationBack: 'Quay lại',
  activateButton: 'Mở {channel}',
  activateWaiting: 'Đang chờ tin nhắn của bạn. Hết hạn sau {time}.',
  startAgain: 'Bắt đầu lại',
  remove: 'Xóa',
  removeAria: 'Xóa số điện thoại {number}',
  removeTitle: 'Xóa {number}?',
  removeDescription:
    'IMAI sẽ ngừng trả lời số này trên iMessage và WhatsApp. Bạn có thể thêm lại bất cứ lúc nào.',
  removeError: 'Không xóa được số. Hãy thử lại.',

  errorInvalidNumber: 'Nhập số điện thoại hợp lệ, gồm cả mã vùng.',
  errorNumberTaken: 'Số này đã được một tài khoản IMAI khác sử dụng.',
  errorRateLimited: 'Thử quá nhiều lần. Hãy đợi một lúc rồi thử lại.',
  errorChannelUnavailable:
    'Tùy chọn này hiện không khả dụng. Hãy chọn tùy chọn còn lại.',
  errorSendFailed: 'Không thể bắt đầu xác minh. Hãy thử lại.',
  errorActivationExpired: 'Lượt kích hoạt này đã hết hạn. Hãy bắt đầu lại.',

  noteSlack: 'Nhắn cho IMAI từ không gian làm việc Slack của bạn.',
  noteTeams: 'Nhắn cho IMAI từ Microsoft Teams.',
  noteTelegram: 'Trò chuyện với bot IMAI trên Telegram.',
  connect: 'Kết nối',
  connectAria: 'Kết nối {channel}',
  connectError: 'Không bắt đầu kết nối {channel} được. Hãy thử lại.',
  connectedOn: 'Đã kết nối {date}',
  accountFallback: 'Tài khoản {channel} của bạn',
  installSlack: 'Thêm IMAI vào không gian làm việc',
  installTeams: 'Thêm IMAI vào Teams',
  openTelegram: 'Mở trong Telegram',
  disconnect: 'Ngắt kết nối',
  disconnectAria: 'Ngắt kết nối {account} khỏi {channel}',
  disconnectError: 'Không ngắt kết nối {channel} được. Hãy thử lại.',
  disconnectTitle: 'Ngắt kết nối {channel}?',
  disconnectDescription:
    'Tin nhắn từ {account} sẽ không đến IMAI nữa. Bạn có thể kết nối lại bất cứ lúc nào.',

  toastConnected: 'Đã kết nối {channel}',
  toastConnectedGeneric: 'Đã kết nối tài khoản',
  toastErrorExpired: 'Đăng nhập mất quá nhiều thời gian. Hãy thử kết nối lại.',
  toastErrorInvalidState:
    'Liên kết đăng nhập này không còn hợp lệ. Hãy thử lại.',
  toastErrorAccountTaken:
    'Tài khoản này đã được kết nối với một người dùng IMAI khác.',
  toastErrorNotMember:
    'Bạn không còn là thành viên của không gian làm việc này.',
  toastErrorProvider: 'Đăng nhập chưa hoàn tất. Hãy thử kết nối lại.',
  toastErrorGeneric: 'Không kết nối được tài khoản. Hãy thử lại.',
};
